import React from 'react';

import {Row, Item, ItemImage, Grid} from './styles';
import {useTheme} from 'styled-components/native';

export function BankShimmer() {
  const theme = useTheme();
  return (
    <Grid>
      <Row>
        <Item>
          <ItemImage shimmerColors={theme.colors.shimmer_placeholder} />
        </Item>
        <Item right>
          <ItemImage shimmerColors={theme.colors.shimmer_placeholder} />
        </Item>
      </Row>
      <Row>
        <Item>
          <ItemImage shimmerColors={theme.colors.shimmer_placeholder} />
        </Item>
        <Item right>
          <ItemImage shimmerColors={theme.colors.shimmer_placeholder} />
        </Item>
      </Row>
    </Grid>
  );
}
